"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("react/jsx-runtime"),r=require("styled-components"),s=require("@vds/toggles"),t=require("@vds-tokens/core"),i=require("../helperText/index.js");function l(e){return e&&e.__esModule?e:{default:e}}var a=l(r);const d=a.default.div.withConfig({displayName:"Wrapper",componentId:"VDS__sc-1jw3dax-0"})`
  display: flex;
  flex-direction: row;
  width: 100%;
`,o=a.default.div.withConfig({displayName:"HelperTextWrapper",componentId:"VDS__sc-1jw3dax-1"})`
  align-items: center;
  display: flex;
  overflow: visible;
  padding-left: ${t.LayoutTokens.space["2X"].value};
`;exports.default=({toggle:r,helperText:t,surface:l="light"})=>e.jsxs(d,{children:[e.jsx(s.Toggle,Object.assign({surface:l},r)),e.jsx(o,{children:t&&e.jsx(i.default,Object.assign({color:"light"===l?"primary":"secondary",size:"small",surface:l},t))})]});
